import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IFilteredMeetingRoomList } from 'types/MeetingRoomType'
// import MeetingRoomService from 'service/MeetingRoomService'
import ImgPreviewModal from './ImgPreviewModal'
// import FavoriteIconButton from 'components/ui/FavoriteIconButton'
import {
  ReservationButton,
  RoomName,
  RoomLocation,
  WorkingHours,
  StyledCard,
  CardHeaderOverlay,
  RoomCapacity,
  Summary,
  CardImgPreview,
  // FavoriteContainer,
} from './styled'

interface ComponentProps {
  room: IFilteredMeetingRoomList
  openModal: (salon: IFilteredMeetingRoomList) => void
}

export default function MeetingRoomCard({ room, openModal }: ComponentProps) {
  const { t } = useTranslation()
  const [previewModal, setPreviewModal] = useState(false)
  const openPreviewModal = () => setPreviewModal(true)
  const closePreviewModal = () => setPreviewModal(false)

  /* ######### Meeting Room Data Destructuring ######### */
  const {
    id,
    name,
    startHourStr,
    endHourStr,
    capacity,
    // IsFavorite,
    meetingRoomInventory,
    floor: { name: floorName, locationName: location, districtName, cityName, countryName, blockName },
  } = room || {}

  /* Variables - functions */
  const openReservationModal = () => openModal(room)
  const locationName = `${location}, ${districtName}, ${cityName}, ${countryName}, ${blockName}, ${floorName}`
  const inventoryList = meetingRoomInventory?.map((mi) => `${mi.meetingRoomInventoryTypeName} (${mi.amount})`).join(
    ', '
  )

  /* Favorite Lactation Room */
  // const [favorite, setFavorite] = useState(IsFavorite)
  // const handleAddFavorite = () => {
  //   MeetingRoomService.addMeetingRoomFavorite(Id).then((r) => setFavorite(true))
  // }
  // const handleRemoveFavorite = () => {
  //   MeetingRoomService.removeMeetingRoomFavorite(Id).then((r) => setFavorite(false))
  // }

  return (
    <StyledCard>
      <CardHeaderOverlay>
        {/* <FavoriteContainer>
          <FavoriteIconButton onSave={handleAddFavorite} onRemove={handleRemoveFavorite} isFavorite={favorite} />
        </FavoriteContainer> */}
      </CardHeaderOverlay>

      <div className="d-flex flex-column align-items-center flex-grow-1 px-3">
        <div className="d-flex flex-column align-items-center text-center flex-grow-1">
          <RoomName>{`${name}`}</RoomName>
          <RoomLocation>{locationName}</RoomLocation>
          <RoomCapacity>
            <i className="pi pi-users"></i>
            <span>{capacity}</span>
          </RoomCapacity>
          <Summary> {inventoryList} </Summary>
        </div>

        <CardImgPreview onClick={openPreviewModal}>
          <i className="pi pi-image" color="#45BFE5"></i>
          <span>{t('meeting-res-modal.room-img-preview')}</span>
        </CardImgPreview>

        <WorkingHours>
          <span className="wh-title">{t('most-used-words.working-hours')}: </span>
          <span>
            {startHourStr} - {endHourStr}
          </span>
        </WorkingHours>
        <ReservationButton onClick={openReservationModal}>{t('buttons.book-reservation')}</ReservationButton>
      </div>

      {previewModal && <ImgPreviewModal roomId={id} open={previewModal} handleClose={closePreviewModal} />}
    </StyledCard>
  )
}
